import React from 'react';
import '../../styles/explore.scss';

function QuickFactsBar({ facts }) {
	if (!facts || facts.length === 0) return null;
	return (
		<div className="container">
			<div className="quick-facts-bar">
				{facts.map((f) => (
					<div key={f.label} className="quick-facts-bar__item">
						<strong>{f.value}</strong>
						<span>{f.label}</span>
					</div>
				))}
			</div>
		</div>
	);
}

export default QuickFactsBar;
